import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { Totes_FlowService } from './Totes.flow.index';

import { ProgrammableLogicController_build_containers_for_plcService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_build_plc_instructionsService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_delete_connectorService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_delete_connector_zone_mappingsService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_ds_connector_mappings_getService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_ds_connectors_getService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_get_containers_ready_for_plcService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_insert_connector_mapping_flowService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_insert_connectorsService } from './ProgrammableLogicController.flow.index';

import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.Totes = this.injector.get(Totes_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public Totes: Totes_FlowService;
  public ProgrammableLogicController: ProgrammableLogicController_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _build_containers_for_plc: ProgrammableLogicController_build_containers_for_plcService;
  public async build_containers_for_plc($inParams: { waveIds?: number[], transaction_id?: string }): Promise< { reasons?: string[], toteGroupingId?: number }> {
    if(!this._build_containers_for_plc) { 
      this._build_containers_for_plc = this.injector.get(ProgrammableLogicController_build_containers_for_plcService);
    }
    return this._build_containers_for_plc.run($inParams);
  }
   
   

   
 
  private _build_plc_instructions: ProgrammableLogicController_build_plc_instructionsService;
  public async build_plc_instructions($inParams: { divertZones?: string[], message_type?: string, tote_number?: string, task_id?: number, pick_ticket_id?: number, warehouse?: string, company?: string, division?: string, message_sequence?: string, tote_groupings_id?: number }): Promise< { plc_instructions?: string, updated?: boolean }> {
    if(!this._build_plc_instructions) { 
      this._build_plc_instructions = this.injector.get(ProgrammableLogicController_build_plc_instructionsService);
    }
    return this._build_plc_instructions.run($inParams);
  }
   
   

   
 
  private _delete_connector: ProgrammableLogicController_delete_connectorService;
  public async delete_connector($inParams: { name?: string, warehouseId?: number }): Promise< { reasons?: string[] }> {
    if(!this._delete_connector) { 
      this._delete_connector = this.injector.get(ProgrammableLogicController_delete_connectorService);
    }
    return this._delete_connector.run($inParams);
  }
   
   

   
 
  private _delete_connector_zone_mappings: ProgrammableLogicController_delete_connector_zone_mappingsService;
  public async delete_connector_zone_mappings($inParams: { connector_id?: string, footprint_zone?: string, connector_zone?: string }): Promise< { reasons?: string[] }> {
    if(!this._delete_connector_zone_mappings) { 
      this._delete_connector_zone_mappings = this.injector.get(ProgrammableLogicController_delete_connector_zone_mappingsService);
    }
    return this._delete_connector_zone_mappings.run($inParams);
  }
   
   

   
 
  private _ds_connector_mappings_get: ProgrammableLogicController_ds_connector_mappings_getService;
  public async ds_connector_mappings_get($inParams: {  }): Promise< { list?: { footprint_zone?: string, connector_zone?: string, connector_id?: string, connector_name?: string, warehouse_name?: string, warehouse_id?: number }[], reasons?: string[] }> {
    if(!this._ds_connector_mappings_get) { 
      this._ds_connector_mappings_get = this.injector.get(ProgrammableLogicController_ds_connector_mappings_getService);
    }
    return this._ds_connector_mappings_get.run($inParams);
  }
   
   

   
 
  private _ds_connectors_get: ProgrammableLogicController_ds_connectors_getService;
  public async ds_connectors_get($inParams: { connector_name?: string, connector_ids?: string[] }): Promise< { list?: { name?: string, warehouseId?: number, type?: string, projectId?: number, orderClassId?: number, connector_id?: string }[], reasons?: string[] }> {
    if(!this._ds_connectors_get) { 
      this._ds_connectors_get = this.injector.get(ProgrammableLogicController_ds_connectors_getService);
    }
    return this._ds_connectors_get.run($inParams);
  }
   
   

   
 
  private _get_containers_ready_for_plc: ProgrammableLogicController_get_containers_ready_for_plcService;
  public async get_containers_ready_for_plc($inParams: { warehouse_id?: number, shipping_container_id?: number, transaction_id?: string, waveIds?: number[] }): Promise< { reasons?: string[] }> {
    if(!this._get_containers_ready_for_plc) { 
      this._get_containers_ready_for_plc = this.injector.get(ProgrammableLogicController_get_containers_ready_for_plcService);
    }
    return this._get_containers_ready_for_plc.run($inParams);
  }
   
   

   
 
  private _insert_connector_mapping_flow: ProgrammableLogicController_insert_connector_mapping_flowService;
  public async insert_connector_mapping_flow($inParams: { connector_zone?: string, connector_id?: string, footprint_zone?: string, connector_name?: string, warehouse_name?: string, warehouse_id?: number }): Promise< { reasons?: string[] }> {
    if(!this._insert_connector_mapping_flow) { 
      this._insert_connector_mapping_flow = this.injector.get(ProgrammableLogicController_insert_connector_mapping_flowService);
    }
    return this._insert_connector_mapping_flow.run($inParams);
  }
   
   

   
 
  private _insert_connectors: ProgrammableLogicController_insert_connectorsService;
  public async insert_connectors($inParams: { name?: string, type?: string, warehouseId?: number, projectId?: number, orderClassId?: number }): Promise<void> {
    if(!this._insert_connectors) { 
      this._insert_connectors = this.injector.get(ProgrammableLogicController_insert_connectorsService);
    }
    return this._insert_connectors.run($inParams);
  }
   
   

   
}
